const screens = process.env.screens && process.env.screens.length > 0 ? process.env.screens : [
    "WORKFLOW", // Quy trình
    "PRE_CERTIFICATE", // Yêu cầu sơ bộ
    "CERTIFICATE_BRIEF", // Hồ sơ thẩm định
    "PRELIMINARY_ASSET", // Định giá sơ bộ
    "CERTIFICATE_ASSET", // Thẩm định tài sản
    "PRICE", // Tài sản so sánh
    "MAP", // Bản đồ
    "CUSTOMER", // Quản lý đối tác
    "MENU_FOLLOW_PROFILE", // Tài khoản khách
    "ROLE", // Quản lý nội bộ
    "CATEGORY", // Quản lý dữ liệu
    "DASHBOARD", // Báo cáo quản trị
    "ACCOUNTING", // Quản lý thanh toán
    "USER", // Thông tin cá nhân
];
const certificate_lookup = process.env.certificate_lookup ? process.env.certificate_lookup : false;
export { screens, certificate_lookup };
